import { useState, useCallback, useEffect } from "react";

interface ValidationErrors {
  basicInfos?: boolean;
  credentials?: boolean;
  creditCardBrands?: boolean;
}

interface UseTabNavigationParams {
  showCredentialsTab?: boolean;
  showBrandsTab?: boolean;
}

export function useTabNavigation(
  errors?: ValidationErrors,
  paramsOrHideBrands?: boolean | UseTabNavigationParams,
) {
  const showCredentialsTab =
    typeof paramsOrHideBrands === "object"
      ? paramsOrHideBrands.showCredentialsTab !== false
      : true;
  const showBrandsTab =
    typeof paramsOrHideBrands === "object"
      ? paramsOrHideBrands.showBrandsTab === true
      : !paramsOrHideBrands;

  const [currentTab, setCurrentTab] = useState(1);
  const [previousTab, setPreviousTab] = useState(1);
  const [isAnimating, setIsAnimating] = useState(false);

  const handleChangeTab = useCallback(
    async (event: React.SyntheticEvent, newValue: number) => {
      event.preventDefault();
      event.stopPropagation();

      if (newValue === currentTab || isAnimating) return;

      if (newValue === 2 && !showCredentialsTab) return;
      if (newValue === 3 && !showBrandsTab) return;

      setPreviousTab(currentTab);
      setIsAnimating(true);
      setCurrentTab(newValue);

      setTimeout(() => {
        setIsAnimating(false);
      }, 300);
    },
    [currentTab, isAnimating, showCredentialsTab, showBrandsTab],
  );

  useEffect(() => {
    if (currentTab === 2 && !showCredentialsTab) {
      setCurrentTab(1);
    }
    if (currentTab === 3 && !showBrandsTab) {
      setCurrentTab(1);
    }
  }, [showCredentialsTab, showBrandsTab, currentTab]);

  const getAnimationDirection = useCallback(
    (current: number, previous: number) => {
      if (current < previous) return "left";
      return "right";
    },
    [],
  );

  const tabErrors = {
    basicInfos: !!errors?.basicInfos,
    credentials: !!errors?.credentials,
    creditCardBrands: !!errors?.creditCardBrands,
  };

  return {
    currentTab,
    previousTab,
    isAnimating,
    handleChangeTab,
    getAnimationDirection,
    tabErrors,
    setCurrentTab,
  };
}
